// extracted by mini-css-extract-plugin
module.exports = {"title":"InfoDialog_title__v1-Il","comment":"InfoDialog_comment__IRWIQ"};